import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll to the top on every route change. Without this, navigating
// from the bottom of a page (e.g. a footer link) opens the new page at the
// same vertical position — the title ends up off-screen.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
